<template>
  <div class="relative-position">
    <div class="d-none d-md-block p-3">
      <div>Subscriptions</div>
      <div class="card shadow my-4">
        <div class="card-body scrollable p-0">
          <div class="d-flex align-items-center p-3">
            <h4 class="mt-3 mb-4">Past Subscriptions</h4>
            <select v-model="items" id="transactions" placeholder="Show" class="ml-2 form-control form-control-sm"
              style="width: 60px;">
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="40">40</option>
              <option value="80">80</option>
            </select>
          </div>
          <div class="mx-4">
            <div class="row px-3 align-items-center">
              <div class="col-1"></div>
              <div class="col"><b>Amount</b></div>
              <div class="col"><b>Payment Method</b></div>
              <div class="col"><b>Date</b></div>
            </div>
            <div v-if="memberships.length > 0">
              <div class="row border rounded p-3 my-2 align-items-center" v-for="(membership, index) in memberships"
                :key="index" v-if="index + 1 <= items">
                <div class="col-1"><i class="fa fa-credit-card"></i></div>
                <div class="col">{{ commas(membership.amount) }}/=</div>
                <div class="col">{{ membership.mode_of_payment.name }}</div>
                <div class="col">{{ membership.date_of_payment }}</div>
              </div>
            </div>
            <div v-else>
              <div class="text-primary border rounded p-3 my-2 text-center">
                <img src="@/assets/images/no-data-found.png" alt="NO DATA FOUND" style="height: 200px;">
                <div class="text-default" style="font-size: 20px; margin-top: -40px;"><b>NO DATA FOUND</b></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- Phone -->
    <div class="d-block d-md-none p-3">
      <div>Subscriptions</div>
      <div class="card shadow my-4">
        <div class="card-body scrollable p-0">
          <div class="d-flex align-items-center p-3">
            <h6 class="mt-3 mb-4">Past Subscriptions</h6>
            <select v-model="items" id="transactions" placeholder="Show" class="ml-2 form-control form-control-sm"
              style="width: 60px;">
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="40">40</option>
              <option value="80">80</option>
            </select>
          </div>
          <div class="mx-4">
            <div class="row px-3 align-items-center" style="font-size: 14px;">
              <div class="col-1"></div>
              <div class="col"><b>Amount</b></div>
              <div class="col"><b>Date</b></div>
            </div>
            <div v-if="memberships.length > 0" style="font-size: 13px;">
              <div class="row border rounded p-2 my-2 align-items-center" v-for="(membership, index) in memberships"
                :key="index" v-if="index + 1 <= items">
                <div class="col-1"><i class="fa fa-credit-card"></i></div>
                <div class="col">{{ commas(membership.amount) }}/= <small class="d-block text-primary">{{ membership.mode_of_payment.name }}</small></div>
                <div class="col">{{ membership.date_of_payment }}</div>
              </div>
            </div>
            <div v-else>
              <div class="text-primary border rounded p-3 my-2 text-center">
                <img src="@/assets/images/no-data-found.png" alt="NO DATA FOUND" style="height: 150px;">
                <div class="text-default" style="font-size: 10px;"><b>NO DATA FOUND</b></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { membershipComputed, membershipMethods } from "@/state/helpers";


export default {
  name: "ViewSubscriptions",
  data() {
    return {
      items: 5,
    };
  },
  mounted() {
    this.fetchMemberships();
  },
  computed: {
    ...membershipComputed,
  },

  methods: {
    ...membershipMethods,
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },

  },
};
</script>